module.exports = __webpack_public_path__ + "static/media/event_banner.64373fb4.png";